import axios from 'axios'
import { stringify } from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { AccountRevisionListResponse } from 'src/models/accountRevision.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_BUDGET_REVISIONS_INIT =
  'app/accountHistory/GET_BUDGET_REVISIONS_INIT'
export const GET_BUDGET_REVISIONS_SUCCESS =
  'app/accountHistory/GET_BUDGET_REVISIONS_SUCCESS'
export const GET_BUDGET_REVISIONS_FAILURE =
  'app/accountHistory/GET_BUDGET_REVISIONS_FAILURE'

export interface GetBudgetRevisionsPagination {
  previousCursor?: string
  nextCursor?: string
}
export interface GetBudgetRevisionsSuccessPayload {
  queryParams: GetBudgetRevisionsQueryParams
  revisions: AccountRevisionListResponse[]
  pagination: GetBudgetRevisionsPagination
}

export interface GetBudgetRevisionsInitAction {
  type: typeof GET_BUDGET_REVISIONS_INIT
}
export interface GetBudgetRevisionsSuccessAction {
  type: typeof GET_BUDGET_REVISIONS_SUCCESS
  payload: GetBudgetRevisionsSuccessPayload
}
export interface GetBudgetRevisionsFailureAction {
  type: typeof GET_BUDGET_REVISIONS_FAILURE
  payload: unknown
}

export type GetBudgetRevisionsActions =
  | GetBudgetRevisionsInitAction
  | GetBudgetRevisionsSuccessAction
  | GetBudgetRevisionsFailureAction

const createGetBudgetRevisionsInitAction =
  (): GetBudgetRevisionsInitAction => ({
    type: GET_BUDGET_REVISIONS_INIT,
  })
const createGetBudgetRevisionsSuccessAction = (
  payload: GetBudgetRevisionsSuccessPayload,
): GetBudgetRevisionsSuccessAction => ({
  type: GET_BUDGET_REVISIONS_SUCCESS,
  payload,
})
const createGetBudgetRevisionsFailureAction = (
  err: unknown,
): GetBudgetRevisionsFailureAction => ({
  type: GET_BUDGET_REVISIONS_FAILURE,
  payload: err,
})

export interface GetBudgetRevisionsQueryParams {
  limit?: number
  previousCursor?: string
  nextCursor?: string
  order?: string
}

export const getBudgetRevisions = (
  creditCardId: string,
  queryParams: GetBudgetRevisionsQueryParams,
): ThunkAction<Promise<void>, RootState, void, GetBudgetRevisionsActions> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetBudgetRevisionsActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetBudgetRevisionsInitAction())
    return axios
      .get(
        `/creditcards/${creditCardId}/revisions?${stringify(queryParams)}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(
            createGetBudgetRevisionsSuccessAction({
              ...response?.data,
              queryParams,
            }),
          )
        },
        (err) => {
          dispatch(createGetBudgetRevisionsFailureAction(err.response.data))
        },
      )
  }
}
